import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import App from "./App.tsx";
import "./index.css";

posthog.init("phc_mV9PCTwAmWm8tCpu44pJbowBqrK24RF2WhnzRrg4TqAf", {
  api_host: "https://eu.i.posthog.com",
  autocapture: true,
  capture_pageview: true,
});

createRoot(document.getElementById("root")!).render(<App />);
